export function customGAEvents() {
  ga('create', local.GA_ID, 'auto');

  // GA events for navigation bar
  $('.navbar .navbar-nav a').on('click', function () {
    triggerGAEvent('Top Navigation Bar', this.innerText);
  });

  $('.footer-bottom-menu-location .menu-item a').on('click', function () {
    triggerGAEvent('Footer', this.innerText);
  });

  $('.footer-main-menu-location li a').on('click', function () {
    var $parent = $(this).closest('.site-footer__main__navigation');
    triggerGAEvent($parent.data('event-category'), this.innerText);
  });

  // GA events for Contact form 7
  $('.wpcf7-form .wpcf7-submit').on('click', function (e) {
    var $parent = $(this).closest('.wpcf7-form');
    triggerGAEvent('Form ' + $parent.find('input[name="_page_title"]').val(), $parent.find('input[name="_cf_form_title"]').val());
  });

  // GA events for Blog posts
  $('.latest-blogs.js-fire-event--blog-posts a.blog-card-link').on('click', function (e) {
    var $parent = $(this).closest('section');
    triggerGAEvent($parent.data('event-category'), this.href);
  });

  // GA events for Videos
  $('.js-fire-video-event').on('click', function (e) {
    triggerGAEvent($(this).data('event-category'), $(this).data('event-label'));
  });

  // GA events for buttons
  $('.js-fire-event').on('click', function () {
    var eventLabel = $(this).data('event-label');
    var eventCategory = $(this).data('event-category');

    if (!eventLabel) {
      eventLabel = this.innerText;
    }

    triggerGAEvent(eventCategory, eventLabel);
  });
}

function triggerGAEvent(category, label) {
  ga('send', {
    hitType: 'event',
    eventCategory: category,
    eventAction: 'click',
    eventLabel: label,
    transport: 'beacon'
  });
}